//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UMUM         from "../../../library/umum"        ;
import WILAYAH      from "../../../library/getWilayah"  ;
import CHART        from '../../../library/chart';

export default {
  data() {
    return { 
      cek_load_data:true,
      form : {
        id : '',
        masterJenisUsaha : '',
        des_kel : this.$store.state.ID_DES_KEL,
        jumlah : '',
        tahun : '',
        createdAt : '',
      },
      list_data: [],
      listKegiatan: [],

      page_limit: 1000,
      page_first: 1,
      page_last: 0,
      cari_value: "",

      mdl_lihat : false,

      UMUM: UMUM
    };
  },
  methods: {
    getView : function(){
    //   this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_CNT_DESA_JENIS_USAHA + "view", {
          method: "POST",
          headers: {
          "content-type": "application/json",
        //   authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              data_ke: this.page_first,
              page_limit : this.page_limit,
              tahun: this.form.tahun,
              des_kel : this.form.des_kel
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.list_data = res_data.data;
              this.page_last = res_data.jmlData;
            //   this.$store.commit("hideLoading");
            //   console.log(res_data);
      });
    },
    selectData : function(data){
        this.form.id = data.id;
        this.form.jumlah = data.jumlah;

        this.form.masterJenisUsaha = data.masterJenisUsaha;
        this.form.des_kel = data.des_kel;
        this.form.jumlah = data.jumlah;
        this.form.tahun = data.tahun;

    },

    // ====================================== PAGINATE ====================================
        Notify : function(message, positive, icon){
          this.$q.notify({
            message: message,
            color: positive,
            icon: icon,
            position : 'top',
            timeout: 500,
          })
        },

        cari_data : function(){
            this.page_first = 1;
            this.Jenis_Usaha();
            this.getView();
        },

        indexing : function(index){
            var idx = ((this.page_first-1)*this.page_limit)+index
            return idx
        },
 




    // ====================================== PAGINATE ====================================

    // char_jenis_usaha
    // ====================================== CHART
    Jenis_Usaha : async function(){
      var body = this.form
      var dataArray = await CHART.postData(this.$store.state.url.URL_CNT_DESA_JENIS_USAHA, 'char_jenis_usaha', body);
      console.log(dataArray)
      CHART.BarChart('Potensi_Wilayah', 'Jenis Usaha', 'Data Jenis Usaha', dataArray.uraian, dataArray.jumlah, 'Orang') 
    },
    // ====================================== CHART
  },
  mounted() {


    const d = new Date();
    this.form.tahun = d.getFullYear();
    console.log(this.form.tahun)
    this.form.des_kel = this.$store.state.ID_DES_KEL


    this.$store.state.kegiatan.id = this.$route.query.id;
    // this.$store.commit('getOne')
    this.form.tahun = UMUM.getTahun();
    // this.getView();
    WILAYAH.getListDesKelFull();
    this.cari_data();
  }
};
